var Progress = /** @class */ (function () {
    function Progress() {
        this.finish = false;
    }
    Progress.prototype.start = function () {
        this.finish = false;
    };
    Progress.prototype.setFinish = function (state) {
        this.finish = state;
    };
    Progress.prototype.getFinish = function () {
        return this.finish;
    };
    return Progress;
}());
export default Progress;
